import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// No permissions here by design. A portal session is a single verified
// patient identity (unverified/inactive accounts cannot log in — the
// backend 401s them), and every portal endpoint scopes by the token's
// patient_id, so there is no role dimension for <PermissionGate> to
// check. Per-record eligibility (e.g. appointment.canCancel) arrives as
// server-driven flags instead. Do NOT gate portal actions on staff
// permissions: the staff store is empty in portal sessions and every
// action would disable for all real portal users.

interface PortalUser {
  portalUserId: number;
  patientId: number;
  email: string;
  displayName: string;
  preferredLanguage: string;
  isActive: boolean;
  isVerified: boolean;
}

interface PortalAuthState {
  user: PortalUser | null;
  token: string | null;
  isAuthenticated: boolean;
  setUser: (user: PortalUser) => void;
  setToken: (token: string) => void;
  logout: () => void;
}

export const usePortalAuthStore = create<PortalAuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: true }),
      setToken: (token) => set({ token }),
      logout: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    { name: 'vynaemr-portal-auth' }
  )
);
